export default "__VITE_ASSET__ChSL3rmE__"